module.exports = __webpack_public_path__ + "img/fas-bars.79bb8c7c.svg";